import { useMemo } from 'react';
import { FilterFilled } from '@ant-design/icons';
import { Button } from 'antd';
import useQueryParamsContext from '@/contexts/query-params/useQueryParamsContext';
import { isFormDataModified } from '@/utils/formUtils';
import { AnimateDot } from '../animate-dot';

export default function ToggleFilterButton({
  label,
  onClick,
  defaultParams,
  // A filter the page applies on its own, which the query params don't show.
  isActive = false,
}) {
  const { queryParams } = useQueryParamsContext();

  const isShow = useMemo(() => {
    return isActive || isFormDataModified(queryParams, defaultParams);
  }, [defaultParams, queryParams, isActive]);

  return (
    <Button
      title={label}
      type="default"
      className="btn-default h-8 text-black"
      icon={<FilterFilled className="text-zinc-400" />}
      onClick={onClick}
    >
      <span>{label}</span>

      <AnimateDot show={isShow} />
    </Button>
  );
}
